export default __webpack_public_path__ + "static/media/ic_arrow_right.3518d6df.svg";